import { z } from 'zod';

export const DisplayDTO = z.union([
    z.array(z.literal('webmo')),
    z.array(z.literal('regular')),
    z.tuple([z.literal('regular'), z.literal('webmo')]).or(z.tuple([z.literal('webmo'), z.literal('regular')])),
]);

export type DisplayDTO = z.infer<typeof DisplayDTO>;
